export default __webpack_public_path__ + "static/media/216.8681e603.png";